const indexList = [
  window.location.pathname.indexOf("karriere/jobs"),
  window.location.pathname.indexOf("karriere/job"),
  window.location.pathname.indexOf("plugins/as-jobs"),
  window.location.pathname.indexOf("karriere-1/jobs"),
];

// =============================================================
// MODULES
// =============================================================
if (document.querySelector("[data-ccm-loader-group]") || document.querySelector(".CCMopen")) {
  import("./modules/ccm19.module.js").then((module) => {
    module.init();
  });
}

if (document.getElementById("asjc-url")) {
  import("./modules/asJobs.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_icon_tile_slider")) {
  import("./modules/iconTilesSlider.module.js").then((module) => {
    module.init();
  });
}


if (document.querySelector(".tx-astopicglossary")) {
  import("./modules/asTopicGlossary.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('[data-js="banner-video"]')) {
  import("./modules/bannerVideo.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".bottom-nav")) {
  import("./modules/bottomNav.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".clinic-flyout")) {
  import("./modules/clinicFlyout.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".collapse")) {
  import("./modules/collapse.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".count-up")) {
  import("./modules/countUp.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".header__bottom-nav")) {
  import("./modules/headerBottomNav.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".form-header-search")) {
  import("./modules/headerSearch.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_job_search")) {
  import("./modules/ceJobSearch.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_leistungsspektrum")) {
  import("./modules/ceLeistungsspektrum.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".clinic-finder")) {
  import("./modules/clinicFinder.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".lightbox")) {
  import("./modules/lightbox.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".main-nav")) {
  import("./modules/mainMenu.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".modal")) {
  import("./modules/modal.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".pos-btn")) {
  import("./modules/positionButton.module.js").then((module) => {
    module.init();
  });
}

if (
  document.querySelector(".btn--share-facebook") ||
  document.querySelector(".btn--share-twitter") ||
  document.querySelector(".btn--share-linkedin") ||
  document.querySelector(".btn--share-xing") ||
  document.querySelector(".btn--share-telegram") ||
  document.querySelector(".btn--share-whatsapp") ||
  document.querySelector(".btn--share-mail")
) {
  import("./modules/sharing.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('[data-js="slider-1"]')) {
  import("./modules/slider1.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('[data-js="slider-2"]')) {
  import("./modules/slider2.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('[data-js="slider-3"]')) {
  import("./modules/slider3.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('[data-js="slider-4"]')) {
  import("./modules/slider4.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('.swiper-container--5')) {
  import("./modules/slider5.swiper.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('.content-slider--7')) {
  import("./modules/slider7.swiper.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('section [role="tab"]')) {
  import("./modules/tabs.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".read-more-marker")) {
  import("./modules/readMoreMarker.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ce_salary_calculator")) {
  import("./modules/salaryCalculator.module.js").then((module) => {
    module.init();
  });
}

if (
  document.querySelector(".ctype-ce_falfilebrowser_searchwords .searchwords a")
) {
  import("./modules/lightbox.module.js").then((module) => {
    module.init();
  });
  import("./modules/asFalFilebrowser.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".js-player")) {
  import("./modules/asVideo.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".bmi_content")) {
  import("./modules/bmiRechner.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".grid-wrap")) {
  import("./modules/careerFlyout.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector("button.btn.btn--burger-2")) {
  import("./modules/hideBurgerButtonWithEmptyMenuInDesktop.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".as-training-authorisations--search")) {
  import("./modules/trainingAuthorisations.module.js").then((module) => {
    module.init();
  });
}

// =============================================================
// OTHER
// =============================================================

// if (jobListIndex === -1 && jobOfferIndex === -1) {
//   localStorage.removeItem("prevFlag");
// }

// const preventBack = () => {
//   window.history.forward();
// };
// setTimeout(() => preventBack(), 0);
// window.onunload = function () {
//   null;
// };

// =============================================================
let attempts = 0;

const whenComplete = () => {
  if (++attempts > 30) return;
  attempts += 1;
  if (document.readyState === "complete") {
    let hasValueAboveMinusOne = false;
    for (let i = 0; i < indexList.length; i++) {
      if (indexList[i] > -1) {
        hasValueAboveMinusOne = true;
        break;
      }
    }

    if (hasValueAboveMinusOne) {
      localStorage.setItem("prevFlag", "true");
    } else {
      localStorage.removeItem("prevFlag");
    }
  } else {
    setTimeout(() => whenComplete(), 400);
  }
};
whenComplete();

// =============================================================
// STYLES COMPLETE
// Removes styles_essential when general styles are loaded
// =============================================================
// let styleAttempts = 0;
// const stylesComplete = () => {
//   if (styleAttempts > 30) return;
//   styleAttempts += 1;
//   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
//     document.querySelector("#sess").remove();
//   } else {
//     setTimeout(function () {
//       stylesComplete();
//     }, 300);
//   }
// };
// stylesComplete();
